<template>
    <div class="box directories">
        <h2 class="box-title">
            Directories
        </h2>
        <div class="box-content">
            <base-loader v-if="isLoading" />
            <div v-else-if="hasError">
                <p class="error">
                    Something went wrong. Please refresh the page and try again.
                </p>
            </div>
            <div v-else>
                <p class="intro-text text">
                    Submit your podcast to the directories below so people can listen to your show in their favorite app.
                </p>
                <ul v-if="!!directories" class="directories-list">
                    <li
                        v-for="(data, name) in directories"
                        :key="name"
                        class="directory"
                    >
                        <div class="directory-icon-wrapper">
                            <img
                                class="directory-icon"
                                :src="`/images/directories/${name}.svg`"
                                :alt="data.label"
                                role="presentation"
                            >
                        </div>
                        <h4 class="directory-name">
                            {{ data.label }}
                        </h4>
                        <a :href="data.url" class="btn is-small" target="_blank">Get Listed</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['directories']),

        /**
         * Returns true id directories are loading.
         *
         * @returns {boolean} True if loading.
         */
        isLoading() {
            return null === this.directories;
        },

        /**
         * Returns true if loading directories failed.
         *
         * @returns {boolean} True if failed.
         */
        hasError() {
            return false === this.directories;
        },
    },
};
</script>
